import { Application } from "@hotwired/stimulus";
import { loadControllers } from "stimulus-vite-helpers-2";

const application = Application.start();
const controllers = import.meta.glob("./../../**/*_controller.js", {
  eager: true,
});
// loadControllers(application, controllers);
loadControllers(application, controllers, { nestedMode: true });
